<template>
  <base-edit></base-edit>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'businessOrderDetail',
    components: {
      baseEdit,
    },
  };
</script>
